import { gql } from '@apollo/client'

export const GET_CMS_PAGE = gql`
  query GetUserCMSPage($input: oGetCmsById!) {
    getUserCMSPage(input: $input) {
      sTitle
      sContent
      sAmpContent
      aContent {
        sTagName
        sContent
        sAmpContent
        oProps
        eType
      }
      oCategory {
        oSeo {
          sSlug
        }
        iSeriesId
        oSeries {
          sSrtTitle
          sStatus
        }
      }
      aAlsoReadArticles {
        _id
        sTitle
        sSrtTitle
        oSeo {
          sSlug
        }
        oTImg {
          sUrl
          sText
        }
        oImg {
          sUrl
          sText
        }
      }
      aAlsoReadFArticles {
        _id
        sTitle
        sSrtTitle
        oSeo {
          sSlug
        }
        oTImg {
          sUrl
          sText
        }
        oImg {
          sUrl
          sText
        }
      }
    }
  }
`
export const INSERT_CONTACT = gql`
  mutation InsertContact($input: addContactInput) {
    insertContact(input: $input) {
      sMessage
    }
  }
`
export const GET_CONTACT_QUERY_TYPE = gql`
  query GetContactQueryType {
    getContactQueryType {
      sLabel
      sValue
    }
  }
`
